import {useMemo} from 'react';
import {useSelector} from 'react-redux';

const selectQuery = state => state.query;
export function useQuery() {
    return useSelector(selectQuery);
}

export function useConditions() {
    const query = useQuery();
    return useMemo(() => query?.AND, [query]) ?? [];
}

export function useCondition(conditionIndex) {
    const conditions = useConditions();
    return useMemo(() => {
        return conditions[conditionIndex];
    }, [conditions, conditionIndex]);
}

export function useSubCondition(conditionIndex, subConditionIndex) {
    const condition = useCondition(conditionIndex);
    return useMemo(() => {
        return condition?.OR[subConditionIndex];
    }, [condition, subConditionIndex]);
}
